import { ReactElement, useEffect } from "react";
import AlarmTable from "./alarmTable";
import FilterComponentBase from "../../components/filterComponentBase";
import { IFilterData, IState } from "../../types";

import mockData from "./mockData.json";
import { useSelector } from "react-redux";

const AlarmPage = (): ReactElement => {
  const filter = useSelector<IState, IFilterData>(state => state.filter);

  return(
    <div className="display-flex-column">
      <FilterComponentBase loading={false}/>
      <AlarmTable data={mockData.data} />
    </div>
  );
};

export default AlarmPage;
